export function getToken() {
    if (localStorage.getItem('token')) return localStorage.getItem('token')
    return null
}

export function removeToken() {
    localStorage.clear()
    return true
}
